'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTokenWei = exports.convertTokenFromLowestUnit = exports.convertFromTokenWei = exports.convertTokenToLowestUnit = exports.convertToTokenWei = exports.getTokenSymbol = exports.getTokenDecimals = exports.findTokenByAddress = undefined;

var _web3Utils = require('web3-utils');

var _bignumber = require('bignumber.js');

var _safeToBn = require('./safeToBn');

var _safeToBn2 = _interopRequireDefault(_safeToBn);

var _isNumber = require('./isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _roundEth = require('./roundEth');

var _roundEth2 = _interopRequireDefault(_roundEth);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findTokenByAddress = exports.findTokenByAddress = function findTokenByAddress(tokenList, tokenAddress) {
  return tokenList.find(function (token) {
    return token.address.toLowerCase() === tokenAddress.toLowerCase();
  });
};

/**
 * Get the number of decimals for a token at the given token address.
 *
 * @param {Array} tokenList
 * @param {String} tokenAddress
 *
 * @returns {Number}
 */
var getTokenDecimals = exports.getTokenDecimals = function getTokenDecimals(tokenList, tokenAddress) {
  var token = findTokenByAddress(tokenList, tokenAddress);
  if (token) {
    return token.decimals;
  }
  throw new Error('No Token found for address ' + tokenAddress);
};

/**
 * Get the symbol for a token at the given token address.
 *
 * @param {Array} tokenList
 * @param {String} tokenAddress
 *
 * @returns {String}
 */
var getTokenSymbol = exports.getTokenSymbol = function getTokenSymbol(tokenList, tokenAddress) {
  var token = findTokenByAddress(tokenList, tokenAddress);
  if (token) {
    return token.symbol;
  }
  throw new Error('No Token found for address ' + tokenAddress);
};

/**
 * Converts the value to its lowest integer form,
 * by removing the desired number of decimals.
 *
 * @param {String} value
 * @param {Number} decimals
 *
 * @returns {BN}
 */
var convertToTokenWei = exports.convertToTokenWei = function convertToTokenWei(value, decimals) {
  if ((0, _isNumber2.default)(value)) {
    // This is converting to integer, so ensure no decimals, clone to not alter global config.
    var bigNumberClone = _bignumber.BigNumber.clone({ DECIMAL_PLACES: 0 });
    return (0, _safeToBn2.default)(bigNumberClone(value).times(Math.pow(10, decimals)).toString(10));
  }
  throw new Error('Value is not a number');
};

/**
 * Converts a normalized/display value to the lowest unit for a token.
 * Uses address and token list to find the number of decimals to use in conversion.
 *
 * @param {Array} tokenList
 * @param {String} value
 * @param {String} tokenAddress
 *
 * @returns {BN}
 */
var convertTokenToLowestUnit = exports.convertTokenToLowestUnit = function convertTokenToLowestUnit(tokenList, value, tokenAddress) {
  var decimals = getTokenDecimals(tokenList, tokenAddress);
  return convertToTokenWei(value, decimals);
};

/**
 * Converts the integer value to have the desired number of decimals.
 *
 * @param {BN} value
 * @param {Number} decimals
 *
 * @returns {String}
 */
var convertFromTokenWei = exports.convertFromTokenWei = function convertFromTokenWei(value, decimals) {
  if (_web3Utils.BN.isBN(value)) {
    // Allow up to our desired decimal places, clone to not alter global config.
    var bigNumberClone = _bignumber.BigNumber.clone({ DECIMAL_PLACES: decimals });
    var retVal = bigNumberClone(value.toString(10)).div(Math.pow(10, decimals)).toString(10);
    return retVal;
  }
  throw new Error('Value is not a BN');
};

/**
 * Converts from the lowest unit for a token to a normalized/display version.
 * Uses address and token list to find the number of decimals to use in conversion.
 *
 * @param {Array} tokenList
 * @param {BN} value
 * @param {String} tokenAddress
 *
 * @returns {String}
 */
var convertTokenFromLowestUnit = exports.convertTokenFromLowestUnit = function convertTokenFromLowestUnit(tokenList, value, tokenAddress) {
  var decimals = getTokenDecimals(tokenList, tokenAddress);
  return convertFromTokenWei(value, decimals);
};

/**
 * Displays a tokenWei value formatted as tokenEth, rounded to specified decimal places,
 * with token symbol as a suffix.
 *
 * @param {BN} tokenWei
 * @param {Number} tokenDecimals
 * @param {String} tokenSymbol
 * @param {Number} decimalPlaces
 *
 * @returns {String}
 */
var formatTokenWei = exports.formatTokenWei = function formatTokenWei(tokenWei, tokenDecimals) {
  var tokenSymbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var decimalPlaces = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.DEFAULT_ETH_DECIMALS;

  var tokenEth = convertFromTokenWei(tokenWei, tokenDecimals);
  var roundededEth = (0, _roundEth2.default)(tokenEth, decimalPlaces);
  return tokenEth === roundededEth ? (tokenEth + ' ' + tokenSymbol).trim() : (roundededEth + ' ' + tokenSymbol).trim();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/tokenUtilities.js
// module id = 81
// module chunks = 0